import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { FormControl, FormGroup } from '@angular/forms'
import { TranslateService } from '@ngx-translate/core'
import { Subscription } from 'rxjs'
import {
	PayoutStatus,
	PayoutStatusEnum,
} from 'src/app/modules/payout/models/client-payout.enum'
import { SharedService } from 'src/app/shared/services/shared.service'

@Component({
	selector: 'app-client-profile-payout-filter',
	templateUrl: './client-profile-payout-filter.component.html',
	styleUrls: ['./client-profile-payout-filter.component.scss'],
})
export class ClientProfilePayoutFilterComponent implements OnInit {
	@Output() emitFilter = new EventEmitter()
	@Output() emitfilterCount = new EventEmitter()
	@Input() filterData: any = {
		paging: { pageNumber: 1, pageSize: 10 },
		activeTab: 0,
		countryId: null,

		payoutstatus: null,
		fromDate: '',
		toDate: '',
	}
	filterCount = 0
	filterForm = new FormGroup({
		fromDate: new FormControl(null),
		toDate: new FormControl(null),
		payoutstatus: new FormControl(null),
	})

	subscription = new Subscription()
	PaymentStatus = this.sharedServ.returnEnumArray(PayoutStatusEnum)

	constructor(
		public translate: TranslateService,
		private sharedServ: SharedService
	) {}

	ngOnInit(): void {
		this.filterForm.valueChanges.subscribe((val) => {
			this.filterCount = 0
			for (let value in val) {
				if (
					this.getController(value).value ||
					this.getController(value).value == 0
				)
					this.filterCount += 1
				else if (this.getController(value).value?.length) this.filterCount += 1
			}
		})
	}
	paymentChanged(event: any, controller: string) {
		if (event?.checked) {
			!this.getController(controller).value
				? this.getController(controller).setValue([])
				: null
			this.getController(controller).setValue([
				...this.getController(controller).value,
				event.source.value,
			])
		} else {
			let objIndex = [...this.getController(controller).value]?.indexOf(
				event.source.value
			)
			let newArray = this.getController(controller).value
			newArray.splice(objIndex, 1)
			this.getController(controller).setValue(newArray)
		}
	}

	submit() {
		this.filterData = {
			...this.filterData,
			...this.filterForm.getRawValue(),
		}
		this.emitFilter.emit(this.filterData)
		this.emitfilterCount.emit(this.filterCount)
	}
	resetFilter() {
		this.filterForm.reset()

		this.filterData = {
			...this.filterData,
			...this.filterForm.getRawValue(),
		}
		this.emitFilter.emit(this.filterData)
		this.emitfilterCount.emit(this.filterCount)
	}

	getController(controlName: string) {
		return (this.filterForm as FormGroup).controls[controlName]
	}

	ngOnDestroy() {
		this.subscription.unsubscribe()
	}
}
